import React from 'react';
import { FileSpreadsheet, FileText, Download } from 'lucide-react';
export const ExportOptions = () => {
  const handleExport = format => {
    // Implement export logic here
    console.log(`Exporting to ${format}...`);
  };
  return <div className="flex gap-2" data-id="element-1219">
      <button onClick={() => handleExport('csv')} className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-1220">
        <FileText className="h-4 w-4 mr-2" data-id="element-1221" />
        CSV
      </button>
      <button onClick={() => handleExport('excel')} className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-1222">
        <FileSpreadsheet className="h-4 w-4 mr-2" data-id="element-1223" />
        Excel
      </button>
      <button onClick={() => handleExport('pdf')} className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-1224">
        <Download className="h-4 w-4 mr-2" data-id="element-1225" />
        PDF
      </button>
    </div>;
};